import { Empty } from "antd";
import { margin } from "styled-system";
import styled from "styled-components";
export const StyledEmpty = styled(Empty).withConfig({
  displayName: "emptystyles__StyledEmpty",
  componentId: "sc-1jxbqgi-0"
})(["&.ant-empty{", "}"], margin);